import React, { useCallback, useEffect } from 'react';
import { useAtom } from 'jotai';
import { Drawer } from 'antd';
import kpiStore from '@src/globalStore/kpiStore';
import useKPI from '@src/hooks/useKPI';
import { editModeAtom } from './atoms';
import View from './components/View';
import Edit from './components/Edit';
import { StyledContainer } from './styled';
import EmpBadEventDrawer from '@components/common/EmpWidget/EmpBadEventDrawer';

const SPIDrawer = () => {
  const [editMode, setEditMode] = useAtom(editModeAtom);
  const { forceUpdateKpiMetaConfigs } = useKPI();
  const { setIsKpiDrawerOpen, isKpiDrawerOpen, isBadEventDrawerOpen, setIsBadEventDrawerOpen } =
    kpiStore((state: any) => state);

  useEffect(() => {
    if (isKpiDrawerOpen) {
      forceUpdateKpiMetaConfigs();
    } else {
      setEditMode(false);
    }
  }, [isKpiDrawerOpen]);

  const handleSuccess = useCallback(() => {
    forceUpdateKpiMetaConfigs();
  }, [forceUpdateKpiMetaConfigs]);

  return (
    <Drawer
      open={isKpiDrawerOpen}
      placement="right"
      className="kpi-settings-drawer"
      onClose={() => setIsKpiDrawerOpen(false)}
      destroyOnClose={true}
      title="KPI Configuration"
      width={575}
      contentWrapperStyle={isBadEventDrawerOpen ? { transform: 'translateX(-350px)' } : undefined}
    >
      <StyledContainer>
        {editMode ? <Edit /> : <View />}
        <EmpBadEventDrawer
          open={isBadEventDrawerOpen}
          onClose={() => setIsBadEventDrawerOpen(false)}
          destroyOnClose
          onMappedEventSuccess={handleSuccess}
        />
      </StyledContainer>
    </Drawer>
  );
};

export default SPIDrawer;
